module.exports = __webpack_public_path__ + "img/iws.55816937.png";